export default "__VITE_ASSET__DpjHZyTC__";